import { api } from "./config";

export const getAllCountryCodes = async (data) => {
  try {
    const res = await api.get("website/getcountryCodes");
    return res;
  } catch (error) {
    return error.response;
  }
};